import { identity, result } from 'underscore';
import { getBulkApiErrors, CampaignApiError } from '@bingads-webui-campaign/api-errors';

export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AdGroup: 'adGroup',
  Ad: 'ad',
  LocationTargeting: 'locationTargeting',
  AudienceTargeting: 'audienceTargeting',
};

const GENERIC_ERROR_MESSAGE_KEY = _TL_("We've encountered an error and can't continue. Please contact support for further assistance.");

export const genericApiError = new CampaignApiError(GENERIC_ERROR_MESSAGE_KEY);

export const mapBulkUpsertErrors = (errors, bulkUpsertEntityErrorMap, errorProcessor = identity, scenario, i18n, activityLogger) =>
  getBulkApiErrors(errors, scenario, i18n, activityLogger).map((error) => {
    const errorType = error.type;
    const mappedErrorType = result(bulkUpsertEntityErrorMap, errorType, errorType);
    // eslint-disable-next-line no-param-reassign
    error.type = mappedErrorType;
    return errorProcessor(error);
  });

const getBulkUploadEntityType = entitySchema =>
  (entitySchema.properties['bulk-upload-type'] || {}).value ||
  entitySchema.name;

export const getBulkUploadErrorType = entitySchema =>
  `${getBulkUploadEntityType(entitySchema)} Error`;
